import * as c from '../constants';


export function selectHome() {
  return { type: c.HOTKEY_TMP_SELECT_HOTKEY, payload: undefined };
}


export function selectTab(hotkey) {
  return { type: c.HOTKEY_TMP_SELECT_HOTKEY, mode: c.SELECT_MODE_TAB, payload: hotkey };
}


export function selectChild(hotkey) {
  return { type: c.HOTKEY_TMP_SELECT_HOTKEY, mode: c.SELECT_MODE_CHILD, payload: hotkey };
}


export function selectBreadcrumb(crumb) {
  return { type: c.HOTKEY_TMP_SELECT_HOTKEY, mode: c.SELECT_MODE_BREADCRUMB, payload: crumb };
}


export function saveHotkeyTemplate(data) {
  return { type: c.HOTKEY_TMP_SAVE_HOTKEY_TEMPLATE, payload: data };
}


export function editHotkeyTemplate(id) {
  return { type: c.HOTKEY_TMP_EDIT_HOTKEY_TEMPLATE, payload: id };
}


export function deleteHotkeyTemplate(id, reroute = null) {
  return { type: c.HOTKEY_TMP_DELETE_HOTKEY_TEMPLATE, reroute, payload: id };
}


export function resetHotkeyTemplate() {
  return { type: c.HOTKEY_TMP_RESET };
}


export function setTemplateIsFetching() {
  return { type: c.HOTKEY_TMP_SET_FETCHING_STATUS, payload: true };
}


export function setTemplateDoneFetching() {
  return { type: c.HOTKEY_TMP_SET_FETCHING_STATUS, payload: false };
}


export function setTemplateIsSaving() {
  return { type: c.HOTKEY_TMP_SET_SUBMITTING_STATUS, payload: true };
}


export function setTemplateDoneSaving() {
  return { type: c.HOTKEY_TMP_SET_SUBMITTING_STATUS, payload: false };
}


export function setTemplateError(...errors) {
  return { type: c.HOTKEY_TMP_SET_ERROR_STATUS, payload: errors }; 
}


//
// ─── TAB ACTIONS ────────────────────────────────────────────────────────────────
//


export function moveTab(from, to) {
  return { type: c.HOTKEY_TMP_MOVE_TAB, payload: { from, to } };
}


export function addNewTab(tab) {
  return { type: c.HOTKEY_TMP_ADD_NEW_TAB, payload: tab };
}


export function editTab(tab) {
  return { type: c.HOTKEY_TMP_EDIT_TAB, payload: tab };
}


export function deleteTab(tab) {
  return { type: c.HOTKEY_TMP_DELETE_TAB, payload: tab };
}


export function toggleTabActive(tab) {
  return { type: c.HOTKEY_TMP_TOGGLE_TAB_ACTIVE, payload: tab };
}


export function setLevel(level) {
  return { type: c.HOTKEY_TMP_SET_LEVEL, payload: level };
}


export function setTabs(level, tabs) {
  return { type: c.HOTKEY_TMP_SET_TABS, payload: { level, tabs } };
}


export function markLevelSave(level) {
  return { type: c.HOTKEY_TMP_MARK_LEVEL_SAVE, payload: { level } };
}


export function resetLevelSave() {
  return { type: c.HOTKEY_TMP_RESET_LEVEL_SAVE };
}


export function setSelectedTab(level, tab) {
  return { type: c.HOTKEY_TMP_SET_SELECTED_TAB, payload: { level, tab } };
}


export function resetSelectedTab() {
  return { type: c.HOTKEY_TMP_SELECT_TAB, payload: undefined };
}


//
// ─── CHILDREN ACTIONS ───────────────────────────────────────────────────────────
//


export function moveChild(from, to) {
  return { type: c.HOTKEY_TMP_MOVE_CHILD, payload: { from, to } };
}


export function addNewChild(child) {
  return { type: c.HOTKEY_TMP_ADD_NEW_CHILD, payload: child };
}


export function editChild(child) {
  return { type: c.HOTKEY_TMP_EDIT_CHILD, payload: child };
}


export function deleteChild(child) {
  return { type: c.HOTKEY_TMP_DELETE_CHILD, payload: child };
}


export function toggleChildActive(child) {
  return { type: c.HOTKEY_TMP_TOGGLE_CHILD_ACTIVE, payload: child };
}


export function getChildren(tabKeyLevel) {
  return { type: c.HOTKEY_TMP_GET_CHILDREN, payload: tabKeyLevel }
}


export function setChildren(tabKey, children) {
  return { type: c.HOTKEY_TMP_SET_CHILDREN, initial: false, payload: { tabKey, children } };
}


export function setInitialChildren(tabKey, children) {
  return { type: c.HOTKEY_TMP_SET_CHILDREN, initial: true, payload: { tabKey, children } };
}


//
// ─── TEMPLATE ACTIONS ───────────────────────────────────────────────────────────
//


export function setTemplateState(state) {
  return { type: c.HOTKEY_TMP_SET_TEMPLATE_STATE, payload: state };
}


//
// ─── MODAL ACTIONS ──────────────────────────────────────────────────────────────
//


export function showAddModal(mode) {
  return { type: c.HOTKEY_TMP_SHOW_ADD_MODAL, payload: mode };
}


export function resetAddModal() {
  return { type: c.HOTKEY_TMP_RESET_ADD_MODAL };
}


export function resetEditModal() {
  return { type: c.HOTKEY_TMP_RESET_EDIT_MODAL };
}


export function editHotkey(hotkey, mode) {
  return { type: c.HOTKEY_TMP_EDIT_HOTKEY, mode: mode, payload: hotkey };
}
